import { render, staticRenderFns } from "./mailAdd.vue?vue&type=template&id=c7d96570&scoped=true&"
import script from "./mailAdd.vue?vue&type=script&lang=js&"
export * from "./mailAdd.vue?vue&type=script&lang=js&"
import style0 from "./mailAdd.vue?vue&type=style&index=0&id=c7d96570&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d96570",
  null
  
)

export default component.exports